import { useUserStore } from '@/store/modules/user'

export function authPermission(permission) {
  const all_permission = "*:*:*";
  const permissions = useUserStore().getPermission
  console.log('authPermission', permissions)
  if (permission?.length > 0) {
    return permissions.some(v => {
      return all_permission === v || permission.includes(v)
    })
  } else {
    return false
  }
}


export function audioPermission() {
    const navigator = window?.navigator;
    if (!navigator?.permissions?.query) {
        console.warn('浏览器不支持权限检测API，无法主动检测麦克风权限');
        return Promise.resolve('unsupported');
    }
    return navigator.permissions.query({ name: 'microphone' })
        .then(result => {
            switch (result.state) {
                case 'granted':
                    console.log('权限已授予，可初始化麦克风功能');
                    break;
                case 'prompt':
                    console.log('用户未决策，可引导申请权限');
                    break;
                case 'denied':
                    console.log('权限已拒绝，隐藏麦克风功能');
                    requestMicrophone();
                    break;
            }
            return result.state;
        })
        .catch(error => {
            console.error('麦克风权限查询失败：', error);
            return 'denied'; // 异常按拒绝处理，保证返回值一致性
        });
}
